import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import withStyles from '@material-ui/core/styles/withStyles'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'
import Paper from '@material-ui/core/Paper'

import AddIcon from '@material-ui/icons/Add'

import styles from '../../../styles'

import { AddRemoveLayout } from '../../../components/layout'

import * as actions from './actions'
import { uuid } from '../../../functions'



/**
 * Home is the home page for user
 */


const defaultLayout = [0].map((item, key) => ({ i: uuid(), x: key, y: Infinity, w: 10, h: 5, component: null }))

export class Home extends React.Component {
    state = {
        dirty: false
    }

    componentDidMount() {
        this.props.homeInit()
    }

    componentWillUnmount() {
        if (this.state.dirty)
            this.props.updateDashboard(this.state.layout)
        
        this.props.homeQuit()
    }

    onChange(e) {
        this.setState({
            dirty: true,
            layout: [...e]
        })
    }

    render() {
        return (
            <Paper className={this.props.classes.adminTablePaper} elevation={1}>
                <AddRemoveLayout
                    className="layout"
                    layout={this.props.user._embedded.dashboard || defaultLayout }
                    onLayoutChange={e => this.onChange(e)} 
                />
                <Tooltip title="Add">
                <Fab
                  
                  color="primary"
                  className={this.props.classes.adminTableAddButton}
                  aria-label="Add"
                  onClick={this.onCreate}>
                  <AddIcon />
                </Fab>
              </Tooltip>
            </Paper>
        )
    }
}

Home = connect(
    state => ({
        user: state.user.profile
    }),
    dispatch => (
        bindActionCreators(actions, dispatch)
    )
)(withStyles(styles, {withTheme: true})(Home))


// WEBPACK FOOTER //
// ./src/App/Admin/Home/Home.jsx